import { AxiosInstance } from 'axios';
import { plainToInstance } from 'class-transformer';
import { FormResponseDetailDto } from '../commons/dtos/form-response-detail.dto';
import { FormResponseDto } from '../commons/dtos/form-response.dto';
import { FormTypeDetailDto } from '../commons/dtos/form-type-detail.dto';
import { FormTypeDto } from '../commons/dtos/form-type.dto';
import {
  IChatbotAPIResponse,
  IChatbotAPIResponsePagination
} from '../commons/interfaces/chatbotAPI.interface';
import {
  IFormResponse,
  IFormResponseDetail,
  IFormResponseReq,
  IPatchFormResponseReq
} from '../commons/interfaces/form-response.interface';
import { IFormType, IFormTypeDetail } from '../commons/interfaces/form-type.interface';
import Axios from './axios.service';

export default class FormService {
  private request: AxiosInstance;

  constructor() {
    this.request = Axios.getInstance();
  }

  listFormTypes = async () => {
    const response = await this.request.get<IChatbotAPIResponse<IFormType[]>>('/forms/form-types');

    const data = plainToInstance(FormTypeDto, response.data.data);

    return { data };
  };

  listFormTypeResponse = async (uniqueCode: string, page: number, filters: string) => {
    const response = await this.request.get<IChatbotAPIResponsePagination<IFormResponse[]>>(
      `/forms/form-types/${uniqueCode}/responses?${filters}`,
      { params: { pageSize: 10, page } }
    );

    const data = plainToInstance(FormResponseDto, response.data.data);

    return { data, pagination: response.data.pagination };
  };

  getFormType = async (uniqueCode: string) => {
    const response = await this.request.get<IChatbotAPIResponse<IFormTypeDetail>>(
      `/forms/form-types/${uniqueCode}`
    );

    const data = plainToInstance(FormTypeDetailDto, response.data.data);

    return { data };
  };

  createFormResponse = async (uniqueCode: string, formResponseData: IFormResponseReq) => {
    await this.request.post<Record<string, never>>(
      `/forms/form-types/${uniqueCode}/responses`,
      formResponseData
    );
  };

  getFormResponse = async (formResponseId: string) => {
    const response = await this.request.get<IChatbotAPIResponse<IFormResponseDetail>>(
      `/forms/responses/${formResponseId}`
    );

    const data = plainToInstance(FormResponseDetailDto, response.data.data);

    return { data };
  };

  modifyFormResponse = async (formResponseId: string, requestData: IPatchFormResponseReq) => {
    await this.request.patch<Record<string, never>>(
      `/forms/responses/${formResponseId}`,
      requestData
    );
  };

  exportFormTypeResponses = async (uniqueCode: string) => {
    try {
      const response = await this.request.post(
        `/forms/form-types/${uniqueCode}/responses/export`,
        {},
        { responseType: 'blob' }
      );

      const outputFilename = uniqueCode + '.xlsx';
      const url = URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', outputFilename);
      link.click();
      link.remove();

      return response;
    } catch (err: any) {
      throw new Error(err);
    }
  };
}
